// Modules
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'
import useNotices from 'hooks/system/useNotices'
import useTheme from 'hooks/system/useTheme'

// Styles
import './GoogleIdentity.scss'

// Data (Local)
const typeButtonPropertyMapping = {
	continue: 'continue_with',
	signUp: 'signup_with',
	signIn: 'signin_with'
}

// Component: External > Google identity
function GoogleIdentity ({ className, isInitialized, onResponse, style, type }) {
	// References
	const button = useRef()

	// State
	const [hasError, setHasError] = useState(false)

	// Data
	const { theme } = useTheme()
	const { addNotice } = useNotices()
	// const { language } = useLanguage('components.external.providerButton.components.googleIdentity')

	// Effects
	useEffect(() => {
		if (isInitialized) {
			if (!!window.google) {
				window.google.accounts.id.initialize({
					callback: onResponse,
					client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID
				})
				window.google.accounts.id.renderButton(button.current, {
					locale: 'en',
					shape: 'rectangular',
					size: 'large',
					text: typeButtonPropertyMapping[type] || 'continue_with',
					theme: theme === 'dark' ? 'filled_black' : 'outlined',
					type: 'standard',
					width: 320
				})
				// google.accounts.id.prompt()
			} else setHasError(true)
		}
	}, [addNotice, isInitialized, onResponse, theme, type])

	// Render
	if (!isInitialized || hasError) return null
	return (
		<span
			ref={button}
			data-component="google-identity"
			className={
				'aix-google-identity' +
				(className ? ` ${className}` : '')
			}
			style={style}>
		</span>
	)
}

// Properties
GoogleIdentity.propTypes = {
	className: PropTypes.string,
	isInitialized: PropTypes.bool.isRequired,
	onResponse: PropTypes.func.isRequired,
	style: PropTypes.object,
	type: PropTypes.oneOf(['continue', 'signUp', 'signIn'])
}

// Export
export default GoogleIdentity
